<template>
  <div class="row text-right netpa-list-page-card-wrap" :class="wrapClass">
    <div class="col-12">
      <div class="card netpa-list-page-card">
        <div class="card-header netpa-list-page-card__intro" dir="rtl">
          <div class="netpa-list-page-card__intro-content">
            <b class="text-warning netpa-list-page-card__title">{{ title }}<template v-if="description">،</template></b
            ><span v-if="description" class="text-light netpa-list-page-card__desc">
              {{ description }}</span
            >
          </div>
          <button
            v-if="showBack"
            type="button"
            class="netpa-list-page-card__back-btn"
            title="بازگشت به صفحه قبلی"
            @click="Back"
          >
            <i class="fas fa-arrow-left text-warning" aria-hidden="true"></i>
          </button>
          <button
            v-if="showClose"
            type="button"
            class="netpa-list-page-card__back-btn"
            title="بستن"
            data-dismiss="modal"
          >
            <i class="fas fa-times text-warning" aria-hidden="true"></i>
          </button>
        </div>
        <div v-if="$slots.toolbar" class="card-header netpa-list-page-header">
          <slot name="toolbar"></slot>
        </div>
        <div class="card-body netpa-list-page-card__body">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NetPaListPageCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    backRoute: {
      type: String,
      default: "",
    },
    wrapClass: {
      type: String,
      default: "no-print",
    },
  },
  methods: {
    Back() {
      if (this.backRoute) {
        this.$router.push(this.backRoute);
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>
